<template>
  <div id="map-lodging-show">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <mapbox
                access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
                :map-options="{
                style: 'mapbox://styles/mapbox/streets-v10',
                zoom: 14,
                center: selectedCenter,
                dragRotate: !isMobileDevice,
                touchZoomRotate: isMobileDevice ? false : true,
                pitchWithRotate: false,
                dragPan: true,
                scrollZoom: true,
                doubleClickZoom: true,
                touchZoomRotate: true
              }"
              @map-init="handleMapInit"
            />
          </div>
        </div>
        <div class="closing">
          <span class="close-button" @click="$emit('close')">
            <i class="fas fa-times"></i>
          </span>
        </div>
      </div>
    </transition>
    <Cardmap
    v-if="selectedLodgingDetails"
    class="floating-cardmap-show"
    :lodging="selectedLodgingDetails"
    :idMarker="selectedLodgingId"
    :position="cardPosition"
    @unselect="unselectCardMap"/>
    <SimpleCardmap 
    v-if="hoveredLodging && hoveredMarkerId && !selectedLodgingDetails && !isMobileDevice" 
    :lodging="hoveredLodging" 
    :position="hoverCardPosition" 
    @card-hover="handleCardHover" />
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';
import Cardmap from '../../components/cards/Cardmap.vue';
import SimpleCardmap from '../../components/cards/SimpleCardmap.vue';
import 'mapbox-gl/dist/mapbox-gl.css'

export default {
  name: 'MapLodgingShow',
  props: {
    selectedLodging: {
      type: Object,
      required: true
    },
    nearbyLodgings: {
      type: Array,
      default: () => []
    }
  },
  components: { Mapbox, Cardmap, SimpleCardmap },
  data() {
    return {
      mapInstance: null,
      markerRefs: [],
      selectedLodgingId: null,
      selectedLodgingDetails: null,
      cardPosition: 'right',
      isMobileDevice: window.innerWidth <= 600,
      hoverTooltip: null,
      hoveredLodging: null,
      hoveredMarkerId: null,
      hoverCardPosition: { x: 0, y: 0 },
      hoverTimeout: null,
      cardHovered: false,
      isPhone: window.innerWidth <= 768,
    }
  },
  computed: {
    selectedCenter() {
      return [this.selectedLodging.longitude, this.selectedLodging.latitude]
    }
  },
  watch: {
    nearbyLodgings: {
      handler(newVal) {
        if (this.mapInstance) {
          setTimeout(() => this.displayMarkers(), 50);
        }
      },
      immediate: true,
      deep: true
    },
    selectedLodging: {
      handler(newVal) {
        if (this.mapInstance && newVal && newVal.latitude && newVal.longitude) {
          setTimeout(() => this.displayMarkers(), 50);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleMapInit(map) {
      console.log('🗺️ Map initialized:', map);
      this.mapInstance = map;

      // Safely wait for next tick before trying to interact
      this.$nextTick(() => {
        setTimeout(() => {
          console.log('📍 Calling displayMarkers from handleMapInit');
          console.log('nearbyLodgings length:', this.nearbyLodgings?.length);
          console.log('selectedLodging exists:', !!this.selectedLodging);
          this.displayMarkers();
        }, 100);
      });
    },
  
    displayMarkers() {
      const map = this.mapInstance;
      if (!map) return;

      console.log('🗺️ displayMarkers called');
      console.log('selectedLodging:', this.selectedLodging);
      console.log('nearbyLodgings:', this.nearbyLodgings);

      // Clear existing markers
      this.markerRefs.forEach(marker => {
        if (marker && typeof marker.remove === 'function') {
          marker.remove();
        }
      });
      this.markerRefs = [];

      const bounds = new mapboxgl.LngLatBounds();

      // Add selected lodging marker (black)
      const selected = this.selectedLodging;
      console.log('Selected lodging check:', {
        exists: !!selected,
        hasLat: selected?.latitude,
        hasLng: selected?.longitude,
        lat: selected?.latitude,
        lng: selected?.longitude
      });
      if (selected && selected.latitude && selected.longitude) {
        const selectedEl = document.createElement('div');
        selectedEl.classList.add('price-label', 'black-marker');
        selectedEl.dataset.id = selected.id;
        selectedEl.innerText = `${selected.lowest_price}€`;

         // Add hover events for selected lodging
         selectedEl.addEventListener('mouseenter', (e) => {
           this.handleMarkerHover(selected.id, e, selected);
         });
         
         selectedEl.addEventListener('mouseleave', () => {
           this.handleMarkerLeave();
         });

          // Add click event for selected lodging
          selectedEl.addEventListener('click', () => {
            this.selectedLodgingId = selected.id;
            this.selectedLodgingDetails = selected;
            this.centerAndZoomLodging(selected);
          });

        const selectedMarker = new mapboxgl.Marker(selectedEl)
          .setLngLat([selected.longitude, selected.latitude])
          .addTo(map);

        console.log('✅ Selected lodging marker added:', {
          id: selected.id,
          name: selected.name,
          lat: selected.latitude,
          lng: selected.longitude,
          marker: selectedMarker
        });

        this.markerRefs.push(selectedMarker);
        bounds.extend([selected.longitude, selected.latitude]);
      }

      // Add nearby lodging markers (green)
      this.nearbyLodgings.forEach(lodging => {
        if (!lodging.latitude || !lodging.longitude) return;

        const el = document.createElement('div');
        el.classList.add('price-label', 'green-marker');
        el.dataset.id = lodging.id;
        el.innerText = `${lodging.lowest_price}€`;

         // Add hover events
         el.addEventListener('mouseenter', (e) => {
           this.handleMarkerHover(lodging.id, e, lodging);
         });
         
         el.addEventListener('mouseleave', () => {
           this.handleMarkerLeave();
         });

         // Add click event to show card map
         el.addEventListener('click', () => {
           this.selectedLodgingId = lodging.id;
           this.selectedLodgingDetails = lodging;
           this.centerAndZoomLodging(lodging);
         });

        const marker = new mapboxgl.Marker(el)
          .setLngLat([lodging.longitude, lodging.latitude])
          .addTo(map);

        this.markerRefs.push(marker);
        bounds.extend([lodging.longitude, lodging.latitude]);
      });

      // Fit map to show all markers with padding
      if (this.markerRefs.length > 1 ) {
        map.fitBounds(bounds, {
          padding: 80,
          maxZoom: 16,
          duration: 1000
        });
      }

      // Add user location control
      map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: { enableHighAccuracy: true },
        trackUserLocation: true,
        showUserHeading: true
      }));
    },
    
    showTooltip(event, lodgingName) {
      // Remove existing tooltip
      this.hideTooltip();
      
      // Create tooltip element
      const tooltip = document.createElement('div');
      tooltip.classList.add('lodging-tooltip');
      tooltip.innerText = lodgingName;
      
      // Position tooltip
      const rect = event.target.getBoundingClientRect();
      tooltip.style.position = 'fixed';
      tooltip.style.left = `${rect.left + rect.width / 2}px`;
      tooltip.style.top = `${rect.top - 35}px`;
      tooltip.style.transform = 'translateX(-50%)';
      tooltip.style.zIndex = '10000';
      
      document.body.appendChild(tooltip);
      this.hoverTooltip = tooltip;
    },
    
     hideTooltip() {
       if (this.hoverTooltip) {
         document.body.removeChild(this.hoverTooltip);
         this.hoverTooltip = null;
       }
     },
     
     handleMarkerHover(lodgingId, event, lodgingData) {
       clearTimeout(this.hoverTimeout);
       this.hoveredMarkerId = lodgingId;
       this.hoveredLodging = lodgingData;

       this.$nextTick(() => {
         const rect = event.target.getBoundingClientRect();
         const mapContainer = document.getElementById('map-lodging-show').getBoundingClientRect();

         const isDesktop = window.innerWidth >= 768;
         const hoverCardWidth = isDesktop ? 380 : 250;
         const hoverCardHeight = isDesktop ? 200 : 160; // Approximate card height
         const padding = 20;

         // Position relative to viewport (for use with SimpleCardmap)
         let xViewport = rect.left + rect.width / 2;
         let yViewport = rect.top + 30;

         // Check if showing below would overflow the viewport
         const overflowsBottom = yViewport + hoverCardHeight + padding > window.innerHeight;

         // Check if showing to the right would overflow
         const overflowsRight = xViewport + hoverCardWidth / 2 + padding > window.innerWidth;
         const overflowsLeft = xViewport - hoverCardWidth / 2 - padding < 0;

         // Adjust Y position - if overflows bottom, show above the marker
         if (overflowsBottom) {
           yViewport = rect.top - hoverCardHeight - 10; // Show above marker with spacing
         }

         // Adjust X position if needed
         if (overflowsRight) {
           xViewport = window.innerWidth - hoverCardWidth / 2 - padding;
         } else if (overflowsLeft) {
           xViewport = hoverCardWidth / 2 + padding;
         }

         this.hoverCardPosition = {
           x: xViewport,
           y: yViewport
         };
       });
     },
     
     handleMarkerLeave() {
       this.hoverTimeout = setTimeout(() => {
         if (!this.cardHovered) {
           this.hoveredMarkerId = null;
           this.hoveredLodging = null;
         }
       }, 200);
     },
     
     handleCardHover(isHovering) {
       this.cardHovered = isHovering;
       if (isHovering) {
         clearTimeout(this.hoverTimeout);
       } else {
         this.hoverTimeout = setTimeout(() => {
           this.hoveredMarkerId = null;
           this.hoveredLodging = null;
         }, 200);
       }
     },
    
     centerAndZoomLodging(lodging) {
       if (!this.mapInstance || !lodging.latitude || !lodging.longitude) return;

       this.mapInstance.flyTo({
         center: [lodging.longitude, lodging.latitude],
         zoom: 16,
         duration: 1000
       });
     },

     unselectCardMap() {
       this.selectedLodgingId = null;
       this.selectedLodgingDetails = null;

       // Zoom out to include selected + nearby
       if (this.mapInstance && this.nearbyLodgings.length > 0) {
         const bounds = new mapboxgl.LngLatBounds();

         // Include selected lodging
         bounds.extend([this.selectedLodging.longitude, this.selectedLodging.latitude]);

         // Include nearby lodgings
         this.nearbyLodgings.forEach(l => {
           if (l.longitude && l.latitude) {
             bounds.extend([l.longitude, l.latitude]);
           }
         });

         this.mapInstance.fitBounds(bounds, {
           padding: 50,
           duration: 800,
           maxZoom: 14
         });
       }
     },
    preventBodyScroll() {
      if (!this.isPhone) {
        return;
      }
      // Prevent body scrolling when modal is open
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    },
    restoreBodyScroll() {
      if (!this.isPhone) {
        return;
      }
      // Restore body scrolling when modal is closed
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    },

  },
  mounted() {
    console.log('✅ selectedLodging in map show:', this.selectedLodging)
    console.log('✅ nearbyLodging in map show:', this.nearbyLodgings)
    const bmBurgerButton = document.querySelector('.bm-burger-button');
    if (bmBurgerButton) {
      bmBurgerButton.style.display = 'none';
    }
    this.preventBodyScroll();
  },
  beforeDestroy() {
    const bmBurgerButton = document.querySelector('.bm-burger-button');
    if (bmBurgerButton) {
      bmBurgerButton.style.display = 'block';
    }
    this.hideTooltip();
    this.restoreBodyScroll();
  }
}
</script>
<style lang="scss" scope='app/assets/stylesheets/components/map'>
.close-button {
width: 36px;
height: 36px;
background: #ddd;
border-radius: 8px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
}

.modal-container > #map > .mapboxgl-canvas-container :nth-child(2) {
  filter: none;
  z-index: 100;
  height: fit-content;
  border: 0px;
  // background-image: url('../images/1 Pin.svg');
}

@media (max-width: 480px) {
  #map-lodging-show #map {
    height: 80vh;
  }
}

#map-lodging-show {
   .mapboxgl-map {
     width: 100% !important;
     height: 100% !important;
   }
}

.mapboxgl-canvas{
  width: 100% !important;
  height: 100% !important;
}
#map-lodging-show #map {
  width: 100% !important;
  height: 100% !important;
}

#map-lodging-show .closing{
  margin: 1rem;
}
#map-lodging-show .modal-wrapper{
  width: 100%;
}

#map-lodging-show{
  #card-map{
    top: 51%;
    left: 30%;
    right: auto;
  }

  @media screen and (max-width: 480px) {
   z-index: 1002;
  }
}

.marker {
  // background-image: url('../images/1 Pin.svg');
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
}

.price-label {
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 13px;
  color: white;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.green-marker {
  background-color: #3b6152;
  height: fit-content !important;
  border: 0px !important;
}

.black-marker {
  background-color: black !important;
}

.lodging-tooltip {
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.lodging-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
}

#map-lodging-show .modal-container{
   width: 100% !important;
   height: 100vh !important;
}

.floating-cardmap-show {
    position: fixed !important;
    z-index: 9999 !important;
    top: 60% !important;
    left: 54% !important;
    transform: translate(-50%, -50%) !important;
    width: auto !important;
    max-width: 90vw !important;

    @media screen and (max-width: 768px) {
      left: 50% !important;
    }
}

@media (max-width: 480px) {
  #map-lodging-show .modal-mask{
    display: flex !important;
    flex-direction: column-reverse !important;
  }
  #map-lodging-show .modal-container{
  margin-top: 0px;
  width: 100% !important;
  height: 100% !important;
  padding: 0px !important;
  margin: 0px !important;
  }
  #map-lodging-show .modal-wrapper{
  height: 100%;
  }
  #map-lodging-show .closing{
    margin-right: 0px;
  }
}

#map-lodging-show .closing{
  margin: 1rem;
}
#map-lodging-show .modal-wrapper{
  width: 100%;
}

.marker {
  // background-image: url('../images/1 Pin.svg');
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
}

.price-label {
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 13px;
  color: white;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.green-marker {
  background-color: #3b6152;
  height: fit-content !important;
  border: 0px !important;
}

.black-marker {
  background-color: black;
}
#map-lodging-show .modal-mask{
  height: 100% !important;
}
</style>
<style lang="scss" scoped>
 #map-lodging-show {
  .modal-mask {
    z-index: 1001 !important;
  }
 }
</style>